import React from "react";
import FieldBlock from "./FieldBlock";
import Hint from "../Hint";

export default (InputComponent) => {
  const SimpleFormField = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { input, style, label, hint, meta, ...rest } = props;
    const id = input.id || input.name + input.value;
    return (
      <FieldBlock style={style}>
        <InputComponent id={id} label={label} {...input} {...rest} />
        {hint && <Hint>{hint}</Hint>}
      </FieldBlock>
    );
  };
  SimpleFormField.displayName = `SimpleFormField(${InputComponent.displayName || InputComponent.name || 'Component'})`;
  return SimpleFormField;
};
